import memoize from './memoize';
import * as SuperCategories from '../constants/groupTags/SuperCategory';
import * as SuperCategoryGroup from '../constants/groupTags/SuperCategoryGroup';
import * as CategorySlugs from '../constants/urlSlugs/CategorySlug';
import * as SuperCategorySlug from '../constants/urlSlugs/SuperCategorySlug';
const superCategoryValues = Object.values(SuperCategories);
const getSuperCategoryGroupValues = memoize(superCategory => SuperCategoryGroup[superCategory]);
export const getCategorySuperCategory = memoize(category => {
  switch (category) {
    case 'DATA_MANAGEMENT':
      return 'MARKETING';
    case 'LIVE_CHAT':
      return 'MARKETING';
    case 'VIDEO':
      return 'MARKETING';
    default:
      return superCategoryValues.find(superCategory => {
        const superCategoryGroupValues = getSuperCategoryGroupValues(superCategory);
        return superCategoryGroupValues.includes(category);
      });
  }
});
export const getSuperCategoriesForCategory = memoize(category => {
  return superCategoryValues.filter(superCategory => {
    const superCategoryGroupValues = getSuperCategoryGroupValues(superCategory);
    return superCategoryGroupValues.includes(category);
  });
});
export const getAdminToolSlugDisplay = (category, slug) => {
  const superCategory = getCategorySuperCategory(category);
  return `/${SuperCategorySlug[superCategory]}/${CategorySlugs[category]}/${slug}`;
};